import { FormGroup, HelpBlock, Label, callAll, getId, noop } from 'flos-react-cvi';
import * as React from 'react';

/*
This is a copy paste from `flos-react-cvi` CheckboxField component.

Changed the html structure
 */

function classnames(...classes: Array<string | number | boolean | undefined>) {
    return classes
        .filter(className => (!!className && typeof className === 'string') || typeof className === 'number')
        .join(' ');
}

interface ICheckboxFieldProps
    extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
    /** label to displayed next to checkbox */
    label: React.ReactNode;
    /** id for the checkbox input, which willl be used to set the label as well */
    id?: string;
    /**
     * callback that will be invoked when value is changed. Convenient props so you do not
     * need to get the value from onChange `event.target.checked`.
     */
    onChangeValue?: (checked: boolean) => void;
    /** className to be added to form group container */
    wrapperClassName?: string;
    /** validation status of the field */
    status?: 'success' | 'error' | 'warning';
    /** max width of the field */
    maxWidth?: 'narrow' | 'small' | 'wide' | 'wide-thin';
    /** state if the field is compact, i.e. smaller spacing between elements */
    compact?: boolean;
    /** help text for the field */
    helpText?: string;
}
/**
 * `CheckboxField` is a control that consists of a checkbox and a label
 */
export class CheckboxField extends React.Component<ICheckboxFieldProps> {
    defaultId = getId();

    render() {
        const {
            label,
            id,
            wrapperClassName,
            onChange,
            status,
            maxWidth,
            compact,
            helpText,
            onChangeValue = noop,
            className,
            'aria-checked': ariaChecked,
            ...inputProps
        } = this.props;

        // we provide a default id if developer didn't provide one, so that the component doesn't break without id.
        const idValue = id || this.defaultId;

        return (
            <fieldset
                className={classnames(
                    'tds-CheckboxGroup tds-CheckboxGroup--complex',
                    inputProps.required && 'is-required'
                )}
            >
                <FormGroup className={wrapperClassName} status={status} maxWidth={maxWidth} compact={compact}>
                    <div className="input-list input-list--vertical">
                        <span className="checkbox-group-item">
                            <input
                                id={idValue}
                                onChange={callAll(onChange, ev => onChangeValue(ev.target.checked))}
                                className={classnames('visuallyhidden', className)}
                                aria-checked={ariaChecked || inputProps.checked}
                                {...inputProps}
                                type="checkbox"
                            />
                            <Label
                                htmlFor={idValue}
                                className={classnames(
                                    'checkbox',
                                    status === 'error' && 'has-error',
                                    inputProps.required && 'required',
                                    inputProps.disabled && 'disabled'
                                )}
                            >
                                <span style={{ fontWeight: 300 }}>{label}</span>
                            </Label>
                            {helpText && <HelpBlock>{helpText}</HelpBlock>}
                        </span>
                    </div>
                </FormGroup>
            </fieldset>
        );
    }
}

export default CheckboxField;
